export default __webpack_public_path__ + "logo-BASE-mobile-checkout.svg";